import React, {Component} from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
  Radio,
  RadioGroup
} from '@material-ui/core';
import {Close, Done} from '@material-ui/icons'
import localization from '../../../config/localization';
import GlobalSnackbar, {GlobalSnackbarTypes} from '../../../components/Letflow/Snackbar/GlobalSnackbar';
import FilePondUploader from "../../../components/Letflow/FilePondUploader";
import TranslatableInputs from '../../../components/Letflow/TranslatableInputs';

class HomeBannerElementForm extends Component {

  constructor(props) {
    super(props)
    let translations = (props.translations && props.translations.length > 0) ? JSON.parse(props.translations) : null;
    let translationEs = translations && translations.find(t => t.lang == 'es');
    let translationEn = translations && translations.find(t => t.lang == 'en');
    let translationPt = translations && translations.find(t => t.lang == 'pt');
    this.state = {
      active: props.active ? true : props.title ? false : true ,
      image: {
        src: props.image || null,
        file: null
      },
      title: props.title || '',
      subtitle: props.subtitle || '',
      titleEs: (translationEs && translationEs.title) ? translationEs.title : (props.title || ''),
      subtitleEs: (translationEs && translationEs.subtitle) ? translationEs.subtitle : (props.subtitle || ''),
      titleEn: (translationEn && translationEn.title) ? translationEn.title : '',
      subtitleEn: (translationEn && translationEn.subtitle) ? translationEn.subtitle : '',
      titlePt: (translationPt && translationPt.title) ? translationPt.title : '',
      subtitlePt: (translationPt && translationPt.subtitle) ? translationPt.subtitle : '',
      link: props.link || '',
      newTab: props.newTab || false,
      videoId: null,
      video: { src: props.video || null, file: null },
      previewId: null,
      preview: { src: props.preview || null, file: null },
      submitting: false,
      bannerType: (props.embedUrl && props.embedUrl.length > 0) ? 'youtube' : 'upload',
      embedUrl: props.embedUrl || '',
    }
  }

  onVideoChange = video => video ? this.setState({videoId: video.id, video: {src: null}, videoPreview: this.formNewUrl(video.path)}) : this.setState({videoId: null, video: {src: null}})
  onPreviewChange = preview => preview ? this.setState({previewId: preview.id, preview: {src: null}, videoPreview: this.formNewUrl(preview.path)}) : this.setState({previewId: null, preview: {src: null}})
  handleChange = e => this.setState({ [e.target.id]: e.target.value })

  handleUploadProgress = (current, total) => this.setState({ uploadProgress: Math.floor(current / total * 100) })

  handleSubmit = () => {
    this.setState({ submitting: true })
    const { active, title, subtitle, link, newTab, image, videoId, previewId, embedUrl, bannerType, titleEs, titleEn, titlePt, subtitleEs, subtitleEn, subtitlePt } = this.state
    let translations = [
      {lang: 'es', title: titleEs, subtitle: subtitleEs},
      {lang: 'en', title: titleEn, subtitle: subtitleEn},
      {lang: 'pt', title: titlePt, subtitle: subtitlePt},
    ]
    this.props.submitRequest(active, titleEs, subtitleEs, link, newTab, image.file, videoId, previewId, bannerType == 'youtube' ? embedUrl : '', translations, this.handleUploadProgress)
      .then(() => {
        GlobalSnackbar.show({
          message: localization.get('home_editor.banner_updated'),
          type: GlobalSnackbarTypes.SUCCESS,
        })
        this.setState({ submitting: false })
      })
      .catch(() => {
        GlobalSnackbar.show({
          message: localization.get('home_editor.banner_update_failed'),
          type: GlobalSnackbarTypes.ERROR,
        })
        this.setState({ submitting: false })
      })
  }

  formNewUrl = (path) => {
    return process.env.REACT_APP_CDN_HOST.concat('/' + path)
  }

  render = () => {
    return (
      <Dialog open={true}>
        <DialogTitle>
          <Typography>{this.props.formTitle}</Typography>
        </DialogTitle>
        <DialogContent style={{ width: '500px', maxWidth: '100%' }}>
          <FormControl style={{ width: '100%' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.active}
                  onChange={() => {
                    this.setState({ active: !this.state.active })
                  }}
                />
              }
              label={localization.get('form.active')}
            />
            <TranslatableInputs
              children={[
                {
                  language: 'es',
                  content: [
                    <TextField style={{width: "100%", marginBottom: "20px"}} id='titleEs' label={localization.get('form.title')} value={this.state.titleEs} onChange={this.handleChange} disabled={this.state.submitting} />,
                    <TextField style={{width: "100%", marginBottom: "20px"}} id='subtitleEs' label={localization.get('form.subtitle')} value={this.state.subtitleEs} onChange={this.handleChange} disabled={this.state.submitting} />
                  ]
                },
                {
                  language: 'en',
                  content: [
                    <TextField style={{width: "100%", marginBottom: "20px"}} id='titleEn' label={localization.get('form.title')} value={this.state.titleEn} onChange={this.handleChange} disabled={this.state.submitting} />,
                    <TextField style={{width: "100%", marginBottom: "20px"}} id='subtitleEn' label={localization.get('form.subtitle')} value={this.state.subtitleEn} onChange={this.handleChange} disabled={this.state.submitting} />
                  ]
                },
                {
                  language: 'pt',
                  content: [
                    <TextField style={{width: "100%", marginBottom: "20px"}} id='titlePt' label={localization.get('form.title')} value={this.state.titlePt} onChange={this.handleChange} disabled={this.state.submitting} />,
                    <TextField style={{width: "100%", marginBottom: "20px"}} id='subtitlePt' label={localization.get('form.subtitle')} value={this.state.subtitlePt} onChange={this.handleChange} disabled={this.state.submitting} />
                  ]
                },
              ]}
            />
            <TextField style={{ marginTop: '10px' }} id='link' label={localization.get('form.link')} value={this.state.link} onChange={this.handleChange} disabled={this.state.submitting} />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.newTab}
                  onChange={() => {
                    this.setState({ newTab: !this.state.newTab })
                  }}
                />
              }
              label={localization.get('form.open_new_tab')}
            />
            <FormControl>
              <RadioGroup
                name="bannerType"
                value={this.state.bannerType}
                onChange={e => this.setState({bannerType: e.target.value})}
                style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
              >
                <FormControlLabel value="upload" control={<Radio color="default"/>}
                                  label={localization.get('batch_upload.upload_from_computer')}/>
                <FormControlLabel value="youtube" control={<Radio color="default"/>}
                                  label={'Youtube'}/>
              </RadioGroup>
            </FormControl>
            {this.state.bannerType == 'upload' &&
              <>
                <div style={{ textAlign: 'center', margin: '10px 0' }}>
                  <h3>{localization.get('form.select_video')}</h3>
                  {this.state.video.src && <video width='100%' controls>
                    <source src={this.state.video.src} type='video/mp4' />
                    Your browser does not support HTML5 video.
                  </video>}
                  <FilePondUploader
                    file={this.state.video}
                    id={"video"}
                    type={"video"}
                    allowedTypes={["video/mp4","video/x-m4v","video/*",".mov"]}
                    onIdChange={this.onVideoChange}
                    setPreview={this.setPreview}
                    disableForm={this.state.submitting}
                    updateDisableForm={value => this.setState({submitting: value})}
                    maxFileSize={"300MB"}
                  />
                </div>

                <div style={{ textAlign: 'center', margin: '10px 0' }}>
                  <h3>{localization.get('form.select_video_preview')}</h3>
                  {this.state.preview.src && <video width='100%' controls>
                    <source src={this.state.preview.src} type='video/mp4' />
                    Your browser does not support HTML5 video.
                  </video>}
                  <FilePondUploader
                    file={this.state.preview}
                    id={"preview"}
                    type={"video"}
                    allowedTypes={["video/mp4","video/x-m4v","video/*",".mov"]}
                    onIdChange={this.onPreviewChange}
                    setPreview={this.setPreview}
                    disableForm={this.state.submitting}
                    updateDisableForm={value => this.setState({submitting: value})}
                    maxFileSize={"10MB"}
                  />
                </div>
                <h6 style={{textAlign: "center"}}>{localization.get('video_aspect_ratio', "16:9")}</h6>
              </>
            }
            {this.state.bannerType == 'youtube' &&
              <TextField id='embedUrl' label={"Youtube URL"} value={this.state.embedUrl} onChange={this.handleChange} disabled={this.state.submitting} />
            }
          </FormControl>
        </DialogContent>
        <DialogActions>
          {this.state.submitting && <Typography style={{ position: 'absolute', left: '20px' }}>{localization.get('form.uploading')}: {this.state.uploadProgress || 0}%</Typography>}
          <Button onClick={this.props.onClose} disabled={this.state.submitting}><Close /></Button>
          <Button onClick={this.handleSubmit} disabled={this.state.submitting}><Done /></Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default HomeBannerElementForm